import { ArrowPathIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "@mui/material";

import { InputTextAddon } from "../../../common/Atoms/InputTextAddon";
import { classNames } from "../../../common/lib/classNames";

// GitHub label default palette
export const DEFAULT_TAG_COLORS = [
  `#b60205`, `#d93f0b`, `#fbca04`, `#0e8a16`, `#006b75`, `#1d76db`, `#0052cc`, `#5319e7`,
  `#e99695`, `#f9d0c4`, `#fef2c0`, `#c2e0c6`, `#bfdadc`, `#c5def5`, `#bfd4f2`, `#d4c5f9`,
];

export function randomTagColor() {
  return `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, `0`)}`;
}

interface ITagColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

/** GitHub-labels style color picker: random button, hex input, default swatches */
export function TagColorPicker({ value, onChange }: ITagColorPickerProps) {
  return (
    <div>
      <div className={ `flex items-end gap-2` }>
        <Tooltip title={ `Random color` }>
          <button
            type={ `button` }
            aria-label={ `Random color` }
            onClick={ () => onChange(randomTagColor()) }
            className={ `flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-md text-white` }
            style={ { backgroundColor: value || `#6b7280` } }
          >
            <ArrowPathIcon className={ `h-4 w-4` } />
          </button>
        </Tooltip>
        <InputTextAddon
          value={ value }
          onChange={ e => onChange(e.value.toString()) }
          placeholder={ `#1d76db` }
          className={ `w-32` }
        />
      </div>
      <div className={ `mt-2` }>
        <div className={ `grid w-fit grid-cols-8 gap-1` }>
          { DEFAULT_TAG_COLORS.map(color => (
            <button
              key={ color }
              type={ `button` }
              aria-label={ `Use color ${color}` }
              onClick={ () => onChange(color) }
              className={ classNames(
                `h-6 w-6 cursor-pointer rounded-sm`,
                value === color && `ring-2 ring-gray-500 ring-offset-1`,
              ) }
              style={ { backgroundColor: color } }
            />
          )) }
        </div>
      </div>
    </div>
  );
}
